(function () {
  let tabSwiper;
  function initTabSwiper() {
    const swiperContainer = document.querySelector('.tab-block-text');
    if (!swiperContainer) return;
    const nextBtn = document.querySelector('.swiper-button-next');
    const prevBtn = document.querySelector('.swiper-button-prev');

    if (!nextBtn || !prevBtn) {
      console.warn('Swiper navigation buttons not found.');
      return;
    }
    if (tabSwiper) {
      tabSwiper.destroy(true, true);
    }
    tabSwiper = new Swiper(swiperContainer, {
      slidesPerView: 'auto',
      spaceBetween: 4,
      speed: 500,
      loop: false,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: false,
      on: {
        init: function(swiper) {
          setTimeout(function() {
            const prevBtn = document.querySelector('.swiper-button-prev');
            const nextBtn = document.querySelector('.swiper-button-next');
            if (
              prevBtn && nextBtn &&
              prevBtn.classList.contains('swiper-button-disabled') &&
              nextBtn.classList.contains('swiper-button-disabled')
            ) {
              document.querySelector('.tab-block-text').closest('.block-grid').classList.add('swiper-btn-disabled')
            }
          }, 10);
        }
      },
    });
  }
  document.addEventListener('DOMContentLoaded', initTabSwiper);
  document.addEventListener('shopify:section:load', initTabSwiper);
})();
